import { useContext, type ReactElement, useState } from 'react';
import { ClientSearchCard } from '../Components/ClientSearchCard';
import { ButtonCard } from '../Components/ButtonCard';
import { Legend } from '@/components/Calendar/Legend/Legend';
import { PlanningContainer } from '../Components/PlanningContainer';
import { openReportsModal } from '../Modals/ReportsModal';
import {
  type PlanningContextType,
  StateContext,
} from '@/layouts/Planning/PlanningLayout';
import { openNewTaskModal } from '../Modals/NewTaskModal';

export const PlanAdjustmentPage = (): ReactElement => {
  const { clientPlanId, planId, service, month } =
    useContext<PlanningContextType>(StateContext);
  const [updateKey, setUpdateKey] = useState(0); // Add a state to force rerender

  return (
    <PlanningContainer key={updateKey}>
      <ClientSearchCard planState="PLANNED" key={updateKey} />
      <ButtonCard
        header="Požadavky"
        buttons={[
          {
            label: 'Přidat úkol',
            onClick: () =>
              openNewTaskModal(
                clientPlanId,
                month,
                () => setUpdateKey(prevKey => prevKey + 1) // Update the state to force rerender
              ),
          },
        ]}
      />
      <ButtonCard
        header="Hromadné akce"
        buttons={[
          {
            label: 'PDF Plány',
            onClick: () => openReportsModal(planId, service, 'PLAN'),
          },
        ]}
      />
      <Legend
        label="Legenda"
        colors={[
          {
            label: 'Nepřiřazené',
            color: '#A0A0A0',
          },
          {
            label: 'Přiřazené',
            color: '#0000F0',
          },
        ]}
      />
    </PlanningContainer>
  );
};
